import React from "react";
import { ArrowRight, Clock } from "lucide-react";
import { blogPosts } from "../mock";

const Blog = () => {
  return (
    <section id="blog" className="py-20 md:py-28 bg-[#e8eaed]/60">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 reveal">
          <div className="max-w-xl">
            <span className="text-xs font-semibold tracking-widest uppercase text-[#b89a5a]">
              Blog
            </span>
            <h2 className="font-display font-bold text-3xl md:text-4xl text-[#2f3a45] mt-4">
              Conteúdo sobre saúde ocular
            </h2>
          </div>
          <p className="text-[#4a5a68] md:max-w-sm">
            Informação de qualidade para você cuidar melhor da sua visão.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-7 mt-12">
          {blogPosts.map((p) => (
            <article
              key={p.id}
              className="reveal group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="h-52 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-[#6b7a88]">
                  <span className="bg-[#94a7b8]/15 text-[#2f3a45] font-semibold px-3 py-1 rounded-full">
                    {p.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <Clock className="w-3.5 h-3.5" /> {p.readTime}
                  </span>
                </div>
                <h3 className="font-display font-semibold text-lg text-[#2f3a45] mt-4 group-hover:text-[#b89a5a] transition-colors">
                  {p.title}
                </h3>
                <p className="text-[#6b7a88] text-sm mt-2 leading-relaxed">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-4 text-sm font-semibold text-[#b89a5a]">
                  Ler artigo <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
